import React, { useState, useCallback } from 'react';
import { Button } from 'react-bootstrap';
import { FaPlay } from 'react-icons/fa';
import { Video, VideoSettings } from '../../../../../../dorian-shared/types/video/video';
import { VideoModal } from '../../../../VideoLibraryPage/VideoModal/VideoModal';

interface VideoPreviewButtonProps {
  video: Video;
  videoSettings: VideoSettings;
  isDisabled: boolean;
}

export function VideoPreviewButton({
  video,
  videoSettings,
  isDisabled,
}: VideoPreviewButtonProps): React.ReactElement {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = useCallback(() => {
    setShowModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
  }, []);

  return (
    <>
      <Button
        size="sm"
        variant="secondary"
        className="ml-2 mr-3 my-0 px-2 py-1"
        disabled={isDisabled}
        onClick={handleOpenModal}
        title={`Preview: ${video.title}`}
      >
        <FaPlay size={16} />
      </Button>

      {showModal && (
        <VideoModal
          video={video}
          videoSettings={videoSettings}
          isVisible={showModal}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
}
